import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '../../css';

const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  margin: theme.spacing(2), // Updated to use the new spacing API
  color: colors.colorBlue
}));

function Spinner({ classes, size, thickness }) {
  return <StyledCircularProgress classes={classes} size={size} thickness={thickness} />;
}

Spinner.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number
};

Spinner.defaultProps = {
  size: 45,
  thickness: 4
};

export default Spinner;
